const PlatformFeatureEnum = Object.freeze({
    BASIC_VISIBILITY_GROUPS: 'BASIC_VISIBILITY_GROUPS',
    ADVANCED_VISIBILITY_GROUPS: 'ADVANCED_VISIBILITY_GROUPS'
});

export default PlatformFeatureEnum;
